<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.3504 11C19.3504 15.6116 15.612 19.35 11.0004 19.35C6.38881 19.35 2.65039 15.6116 2.65039 11C2.65039 6.38841 6.38881 2.64999 11.0004 2.64999C15.612 2.64999 19.3504 6.38842 19.3504 11ZM11.0004 21.15C16.6061 21.15 21.1504 16.6057 21.1504 11C21.1504 5.3943 16.6061 0.849994 11.0004 0.849994C5.3947 0.849993 0.850393 5.3943 0.850392 11C0.850392 16.6057 5.3947 21.15 11.0004 21.15ZM12.0013 15.4749C12.0013 14.9226 11.5536 14.4749 11.0013 14.4749L11.0003 14.4749C10.448 14.4749 10.0003 14.9226 10.0003 15.4749C10.0003 16.0272 10.448 16.4749 11.0003 16.4749L11.0013 16.4749C11.5536 16.4749 12.0013 16.0272 12.0013 15.4749ZM11.0003 5.47858C11.4974 5.47858 11.9003 5.88153 11.9003 6.37858L11.9003 12.0551C11.9003 12.5522 11.4974 12.9551 11.0003 12.9551C10.5032 12.9551 10.1003 12.5522 10.1003 12.0551L10.1003 6.37858C10.1003 5.88153 10.5033 5.47858 11.0003 5.47858Z"
      fill="var(--color-toast-alert-icon)"
    />
  </svg>
</template>
